import {useEffect, useState} from "react";
import {
  useAddCmpConfigConsentableMutation,
  useAddCmpConfigVendorMutation,
  useCreateCmpConfigPurposeMutation,
  useCreateCmpConfigVendorMutation,
  useDeleteCmpConfigVendorMutation,
  useGetCmpConfigPurposesQuery,
  useGetCmpConfigQuery,
  useGetCmpConfigVendorsQuery,
  useGetCmpPreviewQuery,
  useGetDecodeConsentStringQuery,
  useLazyGetCmpAvailableVendorsQuery, useRemoveCmpConfigConsentableMutation,
  useUpdateCmpConfigMutation, useUpdateCmpConfigPurposeMutation,
  useUpdateCmpConfigVendorMutation
} from "../../api/cmpApiSlice";
import {useTranslation} from "react-i18next";

export default function usePublisherCmpConfiguration({configurableType, configurableId, skip = false}) {
  const { i18n } = useTranslation()

  const [appPreviewId, setAppPreviewId] = useState()
  const [consentString, setConsentString] = useState()

  const params = {configurableType, configurableId}

  const {data: cmpConfig = {}, isSuccess: isConfigSuccess, isFetching: isConfigLoading} = useGetCmpConfigQuery(params, {skip})
  const {data: purposes = [], isSuccess: isPurposesSuccess, isFetching: isPurposesLoading} = useGetCmpConfigPurposesQuery({...params, lang: i18n.language}, {skip})
  const {data: vendors = {}, isSuccess: isVendorsSuccess, isFetching: isVendorsLoading} = useGetCmpConfigVendorsQuery({...params, lang: i18n.language}, {skip})
  const {data: preview = {}, isSuccess: isAppPreviewSuccess, isFetching: isAppPreviewLoading} = useGetCmpPreviewQuery({appId: appPreviewId, lang: i18n.language}, {skip: !appPreviewId})
  const {data: decodedConsentString = {}, isConsentStringSuccess} = useGetDecodeConsentStringQuery({consentString}, {skip: !consentString})
  const [updateCmpConfig] = useUpdateCmpConfigMutation()
  const [getAvailableVendors, {data: availableVendors = [], isLoading: isAvailableVendorsLoading},] = useLazyGetCmpAvailableVendorsQuery()
  const [addVendor] = useAddCmpConfigVendorMutation()
  const [updateVendor] = useUpdateCmpConfigVendorMutation()
  const [createVendor] = useCreateCmpConfigVendorMutation()
  const [removeVendor] = useDeleteCmpConfigVendorMutation()
  const [addConsentable] = useAddCmpConfigConsentableMutation()
  const [createPurpose] = useCreateCmpConfigPurposeMutation()
  const [updatePurpose] = useUpdateCmpConfigPurposeMutation()
  const [removeConsentable] = useRemoveCmpConfigConsentableMutation()

  const vendorsLoaderProps = {isSuccess: isVendorsSuccess, isLoading: isVendorsLoading}
  const purposesLoaderProps = {isSuccess: isPurposesSuccess, isLoading: isPurposesLoading}
  const cmpConfigLoaderProps = {isSuccess: isConfigSuccess, isLoading: isConfigLoading}

  const cmpPreviewProps = {
    show: !!appPreviewId,
    setAppPreviewId: setAppPreviewId,
    handleClose: () => setAppPreviewId(null),
    preview: preview,
    setConsentString: setConsentString,
    decodedConsentString: decodedConsentString,
    isAppPreviewLoading: isAppPreviewLoading,
    isAppPreviewSuccess: isAppPreviewSuccess
  }

  const cmpConfigurationProps = {
    cmpConfig: cmpConfig,
    updateCmpConfig: updateCmpConfig,
    params: params,
    vendors: vendors,
    availableVendors: availableVendors,
    getAvailableVendors: getAvailableVendors,
    updateVendor: updateVendor,
    createVendor: createVendor,
    addVendor: addVendor,
    removeVendor: removeVendor,
    vendorsLoaderProps: {...vendorsLoaderProps},
    purposes: purposes,
    languages: cmpConfig.inheritedConfig?.languages,
    isAvailableVendorsLoading: isAvailableVendorsLoading,
    addConsentable: addConsentable,
    createPurpose: createPurpose,
    updatePurpose: updatePurpose,
    removeConsentable: removeConsentable,
    purposesLoaderProps: purposesLoaderProps,
    cmpConfigLoaderProps: cmpConfigLoaderProps
  }

  return {cmpPreviewProps, cmpConfigurationProps}
}
